// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADMIN_USER = "Modr\u00fd kon\u00edk";
export const AUTHOR = "autor";
export const TOPIC_MODERATOR = "Moder\u00e1tor";
